import { render } from "./MPCode.vue?vue&type=template&id=fc8a1b2e&scoped=true&ts=true"
import script from "./MPCode.vue?vue&type=script&lang=ts"
export * from "./MPCode.vue?vue&type=script&lang=ts"

import "./MPCode.vue?vue&type=style&index=0&id=fc8a1b2e&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8a1b2e"]])

export default __exports__